export default "__VITE_ASSET__CWLB76oJ__"